import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import PhoneInput from "react-phone-input-2";
import "./index.css";
import { Col, Row, Form, Stack, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  affiliateOptions,
  assignDistributorAdminRoles,
  StatusCode,
} from "../../../services/helper";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import ValidationSchema from "../../../components/Common/ValidationSchema";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import DistributorTransparentLogo from "../../../Assets/Profile/distributor.svg";
import DistributorWhiteLogo from "../../../Assets/Profile/distributor-white.svg";
import {
  distributorregisteruser,
  getDistributorDetails,
  updateDistributorDetails,
} from "../../../redux/slice/DistributionRegistrationSlice";
import { toast } from "react-toastify";
import TrashIcon from "../../../Assets/svg/trash-icon.svg";
import CustomAutocomplete from "../../../components/Common/MUI/CustomAutocomplete";
import Loader from "../../../components/Common/Loader/PrimaryLoader";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { fetchBrands } from "../../../redux/slice/ProductManagementSlice";

const ManageDistributor = () => {
  const initialValues = {
    distributor_name: "",
    street: "",
    county: "",
    country: "",
    email: "",
    postal_code: "",
    country_code: "+44",
    contact_number: "",
    company_logo: null,
    company_white_logo: null,
    alternate_distributor_name: "",
    is_affiliated_brand: true,
    role: "distributor_superadmin",
  };

  const [companyLogoPreview, setCompanyLogoPreview] = useState(null);
  const [whiteCompanyLogoPreview, setWhiteCompanyLogoPreview] = useState(null);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [manageButton, setManageButton] = useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(id ? true : false);
  const whiteLogoRef = useRef();
  const secWhiteLogoRef = useRef();

  const { brandList } = useSelector((state) => state.PRODUCTMANAGEMENT);
  const { status } = useSelector((state) => state.DISTRIBUTORMANAGEMENT);

  useEffect(() => {
    if (id) {
      const payload = {
        id,
      };

      dispatch(getDistributorDetails(payload))
        .then((res) => {
          try {
            const result = res?.payload;
            const data = result?.data ?? {};

            if (result?.status === 200) {
              setValues((prev) => {
                return {
                  ...prev,
                  distributor_name: data?.distributor_name ?? "",
                  street: data?.street ?? "",
                  county: data?.county ?? "",
                  country: data?.country ?? "",
                  email: data?.email ?? "",
                  postal_code: data?.postal_code ?? "",
                  country_code: data?.country_code ?? "",
                  contact_number: data?.contact_number ?? "",
                  alternate_distributor_name:
                    data?.alternate_distributor_name ?? "",
                  company_logo: data?.company_logo ?? null,
                  company_white_logo: data?.company_white_logo ?? null,
                  is_affiliated_brand: data?.is_affiliated_brand,
                };
              });
              setSelectedBrands(data?.brands ?? []);
              setCompanyLogoPreview(data?.company_logo ?? null);
              setWhiteCompanyLogoPreview(data?.company_white_logo ?? null);
            }
          } catch (error) {
            console.error("Error processing distributor details:", error);
            // Optionally, handle errors or show an alert to the user
          }
        })
        .catch((error) => {
          console.error("Error dispatching action:", error);
          // Handle any errors related to the dispatch itself
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [id]);

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    handleSubmit,
    setValues,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema.distributorInformation,
    onSubmit: async (values) => {
      if (!id) {
        // Ensure the role is set to "distributor_superadmin" in the payload
        const payload = {
          ...values,
          role: "distributor_superadmin",
          brands: selectedBrands,
        };
        const res = await dispatch(distributorregisteruser(payload));
        if (res.payload?.status === 200) {
          navigate("/distributors");
        }
      } else {
        // Ensure the role is set to "distributor_superadmin" in the payload
        const payload = {
          ...values,
          distributor_id: id,
          brands: selectedBrands,
          role: "distributor_superadmin",
        };
        const res = await dispatch(updateDistributorDetails(payload));
        if (res.payload?.status === 200) {
          navigate("/distributors");
        }
      }
    },
  });

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        if (e.target.name === "company_logo") {
          setCompanyLogoPreview(URL.createObjectURL(file));
          setValues({ ...values, company_logo: file });
        } else {
          setWhiteCompanyLogoPreview(URL.createObjectURL(file));
          setValues({ ...values, company_white_logo: file });
        }
      } else {
        toast.error("Please select a valid image file");
      }
    }
  };

  const handleChangeBrand = (value) => {
    setSelectedBrands(value);
  };
  // const userData = DistributorRegisaterData?.data?.distributors || [];

  useEffect(() => {
    dispatch(fetchBrands());
  }, []);

  const removeBrand = (brand) => {
    setSelectedBrands((prev) => prev.filter((item) => item !== brand));
    setManageButton(null);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="bg-white flex-grow-1 d-flex flex-column popup-layout">
      <div
        className="position-sticky bg-white header-section"
        style={{ zIndex: 1 }}
      >
        <h4 className="text-center m-0 fw-bold">
          {id && "Update"} Distributor Information
        </h4>
        <hr className="my-3 my-md-4" />
      </div>
      <Form onSubmit={handleSubmit} className="flex-grow-1 d-flex flex-column">
        <Stack>
          <div className="row row-gap-3">
            <div className="col-md-5 col-lg-6 col-xxl-5 d-flex flex-column gap-3 gap-md-4">
              <div className="companylogo">
                <Form.Group controlId="formBasiccompany_logo">
                  <Form.Control
                    ref={whiteLogoRef}
                    type="file"
                    accept="image/*"
                    name="company_logo"
                    className="d-none"
                    onChange={handleLogoChange}
                    onBlur={handleBlur}
                  />
                </Form.Group>
                <Col
                  style={{
                    maxWidth: "500px",
                  }}
                >
                  <Col className="w-100" style={{ height: "200px" }}>
                    <img
                      src={
                        companyLogoPreview
                          ? companyLogoPreview
                          : DistributorTransparentLogo
                      }
                      alt="company logo"
                      className="w-100 h-100 object-fit-contain"
                    />
                  </Col>
                  <div className="text-center pt-2">
                    <button
                      className="border-0 background-transparent"
                      type="button"
                      onClick={() => whiteLogoRef.current.click()}
                    >
                      Edit
                    </button>
                    {errors.company_logo && touched.company_logo && (
                      <p className="text-danger mt-1 mb-0">
                        {errors.company_logo}{" "}
                      </p>
                    )}
                  </div>
                </Col>
              </div>
              <div className="companylogo">
                <Form.Group controlId="formBasicCompany_white_logo">
                  <Form.Control
                    ref={secWhiteLogoRef}
                    type="file"
                    accept="image/*"
                    name={values.company_white_logo}
                    className="d-none"
                    onBlur={handleBlur}
                    onChange={handleLogoChange}
                  />
                </Form.Group>
                <Col
                  style={{
                    maxWidth: "500px",
                  }}
                >
                  {whiteCompanyLogoPreview ? (
                    <Col
                      className="w-100 gray-background p-2"
                      style={{ height: "200px" }}
                    >
                      <img
                        src={whiteCompanyLogoPreview}
                        alt="white logo"
                        className="w-100 h-100 object-fit-contain"
                      />
                    </Col>
                  ) : (
                    <Col className="w-100" style={{ height: "200px" }}>
                      <img
                        src={DistributorWhiteLogo}
                        alt="white logo"
                        className="w-100 h-100 object-fit-contain"
                      />
                    </Col>
                  )}
                  <div className="text-center pt-2">
                    <button
                      className="border-0 background-transparent"
                      type="button"
                      onClick={() => secWhiteLogoRef.current.click()}
                    >
                      Edit
                    </button>
                    {errors.company_white_logo &&
                      touched.company_white_logo && (
                        <p className="text-danger mt-1 mb-0">
                          {errors.company_white_logo}
                        </p>
                      )}
                  </div>
                </Col>
              </div>
              <Form.Select
                value={values.is_affiliated_brand}
                name="is_affiliated_brand"
                onChange={handleChange}
              >
                <option value="" disabled className="option-title">
                  Is not an affiliate distributor
                </option>
                {affiliateOptions.map((option) => {
                  return (
                    <option value={option.value} key={option.label}>
                      {option.label}
                    </option>
                  );
                })}
              </Form.Select>
            </div>
            <div className="col-md-7 col-lg-6 col-xxl-7">
              <Row className="row-gap-3">
                <Form.Group controlId="distributorName">
                  <Form.Control
                    type="text"
                    name="distributor_name"
                    value={values.distributor_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Distributor name"
                  />
                  {errors.distributor_name && touched.distributor_name && (
                    <p className="text-danger mt-1 mb-0">
                      {errors.distributor_name}
                    </p>
                  )}
                </Form.Group>
                <Form.Group controlId="formBasicStreet">
                  <Form.Control
                    type="text"
                    name="street"
                    value={values.street}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Street"
                  />
                  {errors.street && touched.street && (
                    <p className="text-danger mt-1 mb-0">{errors.street} </p>
                  )}
                </Form.Group>
                <Form.Group controlId="formBasicCounty">
                  <Form.Control
                    type="text"
                    name="county"
                    value={values.county}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="County"
                  />
                  {errors.county && touched.county && (
                    <p className="text-danger mt-1 mb-0">{errors.county} </p>
                  )}
                </Form.Group>
                <Form.Group
                  className="col-12 col-md-6"
                  controlId="formBasicCountry"
                >
                  <Form.Control
                    type="text"
                    name="country"
                    value={values.country}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Country"
                  />
                  {errors.country && touched.country && (
                    <p className="text-danger mt-1 mb-0">{errors.country} </p>
                  )}
                </Form.Group>
                <Form.Group
                  className="col-12 col-md-6"
                  controlId="formBasicPostal"
                >
                  <Form.Control
                    type="text"
                    name="postal_code"
                    value={values.postal_code}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Postal Code"
                  />
                  {errors.postal_code && touched.postal_code && (
                    <p className="text-danger mt-1 mb-0">
                      {errors.postal_code}{" "}
                    </p>
                  )}
                </Form.Group>
                <Col>
                  <hr className="my-0" />
                </Col>
                <Form.Group controlId="formBasicSuperAdmin">
                  <Form.Select
                    value={values.role}
                    name="role"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled
                    className="bg-white"
                  >
                    <option value="" disabled className="option-title">
                      Assigned Role
                    </option>
                    {assignDistributorAdminRoles.map((option) => {
                      return (
                        <option value={option.value} key={option.label}>
                          {option.label}
                        </option>
                      );
                    })}
                  </Form.Select>
                  {errors.role && touched.role ? (
                    <p className="text-danger mt-1 mb-0">{errors.role} </p>
                  ) : null}
                </Form.Group>
                <Form.Group controlId="formBasicBusinessEmail">
                  <Form.Control
                    type="email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Business Email"
                  />
                  {errors.email && touched.email && (
                    <p className="text-danger mt-1 mb-0">{errors.email} </p>
                  )}
                </Form.Group>
                <Col className="d-flex input_2_custom gap-2">
                  <Form.Group controlId="formBasicCountryCode">
                    <div className="phone-input">
                      <PhoneInput
                        name="country_code"
                        disableTyping={true}
                        inputProps={{
                          readOnly: true,
                        }}
                        country={"gb"}
                        placeholder="Phone Number"
                        value={values.country_code}
                        onChange={(value) =>
                          handleChange({
                            target: { name: "country_code", value },
                          })
                        }
                      />
                    </div>
                    {errors.country_code && touched.country_code && (
                      <p className="text-danger mt-1 mb-0">
                        {errors.country_code}
                      </p>
                    )}
                  </Form.Group>
                  <Form.Group
                    className="flex-grow-1"
                    controlId="formBasicNumber"
                  >
                    <Form.Control
                      onKeyPress={(e) => {
                        if (
                          e.key === "e" ||
                          e.key === "E" ||
                          isNaN(Number(e.key))
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                        }
                      }}
                      type="text"
                      pattern="[0-9]*"
                      name="contact_number"
                      value={values.contact_number}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Number"
                    />
                    {errors.contact_number && touched.contact_number && (
                      <p className="text-danger mt-1 mb-0">
                        {errors.contact_number}
                      </p>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </div>
          <hr className="my-4" />
          <div className="py-2 d-flex flex-column row-gap-3">
            <div className="d-flex align-items-center flex-wrap gap-3">
              <h6 className="fw-bold m-0">Alternative Distributor</h6>
              <Form.Group className="flex-grow-1">
                <Form.Control
                  className="w-100"
                  type="text"
                  name="alternate_distributor_name"
                  value={values.alternate_distributor_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Distributor Name"
                />
                {errors.alternate_distributor_name &&
                  touched.alternate_distributor_name && (
                    <p className="text-danger mt-1 mb-0">
                      {errors.alternate_distributor_name}{" "}
                    </p>
                  )}
              </Form.Group>
            </div>
            <CustomAutocomplete
              value={selectedBrands}
              onValueChange={(value) => handleChangeBrand(value)}
              textProps={{
                placeholder: "Add the distributor’s additional brands",
                variant: "outlined",
                name: "brand",
              }}
              autoCompleteProps={{ disableClearable: true, multiple: true }}
              options={brandList}
              showEndAdornment={false}
              noOptionsText="No brand options"
              getOptionLabel={(option) => `${option}`}
              isOptionEqualToValue={(option, value) => option === value}
              sx={{
                "& .MuiAutocomplete-tag": {
                  display: "none",
                },
              }}
            />
            {selectedBrands.length > 0 && (
              <div className="d-flex gap-2 flex-wrap">
                {selectedBrands.map((brand, index) => {
                  return (
                    <Button
                      onClick={() => setManageButton(index + 1)}
                      key={index}
                      className="position-relative"
                    >
                      {brand}
                      {manageButton === index + 1 && (
                        <span
                          className={`close-button-span ${
                            manageButton === index + 1 ? "text-primary" : ""
                          }`}
                        >
                          <IoIosCloseCircleOutline
                            className="cursor text_gray"
                            onClick={() => removeBrand(brand)}
                            size={25}
                          />
                        </span>
                      )}
                    </Button>
                  );
                })}
              </div>
            )}
          </div>
        </Stack>
        <div className="row position-sticky bg-white align-items-end row-gap-3 footer-section">
          <Col xs={12}>
            <hr className="mt-3 mb-0" />
          </Col>
          {id && (
            <Col xs={12} md={id ? 6 : 12} lg={id ? 4 : 12}>
              <div className="disable_delete_action d-flex">
                <button className="user-mng-button" disabled>
                  <Stack direction="horizontal" className="gap-2">
                    <img src={TrashIcon} alt="TrashIcon" />
                    Delete Distributor
                  </Stack>
                </button>
              </div>
            </Col>
          )}
          <Col
            xs={12}
            md={id ? 6 : 12}
            lg={id ? 8 : 12}
            className="col-md-6 d-flex gap-3 flex-wrap-reverse justify-content-end"
          >
            <NavLink
              className={"nav-link d-flex flex-grow-1 flex-sm-grow-0"}
              to="/distributors"
            >
              <button className="btn btn-dark flex-grow-1" type="button">
                Cancel
              </button>
            </NavLink>
            <button
              className="btn btn-primary px-sm-5 flex-grow-1 flex-sm-grow-0"
              type="submit"
            >
              {status === StatusCode.LOADING ? (
                <ButtonLoader />
              ) : id ? (
                "Update Changes"
              ) : (
                "Save Changes"
              )}
            </button>
          </Col>
        </div>
      </Form>
    </div>
  );
};

export default ManageDistributor;
